<template>
  <div class="is-user-avatar">
    <img
      v-if="newUserAvatar"
      :src="newUserAvatar"
      :alt="userName"
    >
    <b-icon
      v-else
      icon="account-circle-outline"
      class="header-icon"
      size="is-medium"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAvatar',
  props: {
    avatar: {
      type: String,
      default: null
    }
  },
  computed: {
    newUserAvatar () {
      if (this.avatar) {
        return this.avatar
      }

      if (this.userAvatar) {
        return this.userAvatar
      }

      return false
    },
    ...mapState([
      'userAvatar',
      'userName'
    ])
  }
}
</script>
